import { atom } from "recoil";

export const pageSizeOptions = [25, 50, 100, 250];

type ActivePageType = "forms.activePage" | "records.activePage" | "quests.activePage";
type RowsPerPageType = "forms.rowsPerPage" | "records.rowsPerPage" | "refunds.rowsPerPage" | "quests.rowsPerPage";

type ActivePage = {
	key: ActivePageType;
	default: number;
};

type RowsPerPage = {
	key: RowsPerPageType;
	default: number;
};

type IsCreateOrUploadDisabled = {
	key: string;
	default: boolean;
};

const initialValueFormsActivePage: ActivePage = {
	key: "forms.activePage",
	default: 0,
};

const initialValueRecordsActivePage: ActivePage = {
	key: "records.activePage",
	default: 0,
};

const initialValueQuestsActivePage: ActivePage = {
	key: "quests.activePage",
	default: 0,
};

const initialFormsRowsPerPage: RowsPerPage = {
	key: "forms.rowsPerPage",
	default: pageSizeOptions[0],
};

const initialRecordsRowsPerPage: RowsPerPage = {
	key: "records.rowsPerPage",
	default: pageSizeOptions[0],
};

const initialQuestsRowsPerPage: RowsPerPage = {
	key: "quests.rowsPerPage",
	default: pageSizeOptions[0],
};

const IsCreateOrUploadDisabledInitialValue: IsCreateOrUploadDisabled = {
	key: "isDataCreationDisabled",
	default: false,
};

export const formsActivePage = atom(initialValueFormsActivePage);
export const recordsActivePage = atom(initialValueRecordsActivePage);
export const questsActivePage = atom(initialValueQuestsActivePage);
export const formsRowsPerPage = atom(initialFormsRowsPerPage);
export const recordsRowsPerPage = atom(initialRecordsRowsPerPage);
export const questsRowsPerPage = atom(initialQuestsRowsPerPage);

export const isDataCreationDisabled = atom(IsCreateOrUploadDisabledInitialValue);
